import request from '@/utils/request'
const apiPath = '/im/imConversationMessage'
const imConversationMessageApi = {
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  byDateGroup(query) {
    return request.get(apiPath + '/tee/GetCountByDateGroup', { params: query })
  },
  create(data) {
    return request.post(apiPath + '/tee/saveForOWN', data)
  },
}
export default imConversationMessageApi
